import {
  NoneOrderDocumentClassDto,
  NoneOrderTagDetailResponse,
  CompanyResponse,
} from "apis/data-contracts";
import { atom } from "recoil";

export const workFormStepState = atom<number>({
  key: "workFormStepState",
  default: 0,
});

export const selectedWorkDocumentClassState = atom<
  NoneOrderDocumentClassDto | undefined
>({
  key: "selectedWorkDocumentClassState",
  default: undefined,
});

export const selectedWorkCompanyState = atom<CompanyResponse | undefined>({
  key: "selectedWorkCompanyState",
  default: undefined,
});

export const selectedWorkPjTagState = atom<
  NoneOrderTagDetailResponse | undefined
>({
  key: "selectedWorkPjTagState",
  default: undefined,
});

export const selectedWorkTopicTagsState = atom<NoneOrderTagDetailResponse[]>({
  key: "selectedWorkTopicTagsState",
  default: [],
});
